import React from "react";
import { BROKER_PHOTO } from "@/lib/siteData";
import { Award, BookOpen, Handshake } from "lucide-react";

export default function About() {
  return (
    <section id="apropos" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5">
          <div className="relative max-w-md">
            <div className="absolute -inset-6 bg-md-accent/10 rounded-[3rem]" />
            <img
              src={BROKER_PHOTO}
              alt="Maël — MD Courtage"
              onError={(e) => { e.target.src = "https://images.pexels.com/photos/17685845/pexels-photo-17685845.jpeg"; }}
              className="relative rounded-[2rem] w-full aspect-[4/5] object-cover"
              data-testid="about-portrait"
            />
            <div className="absolute -bottom-6 -right-6 bg-md-primary text-white p-6 rounded-2xl max-w-[200px] shadow-xl">
              <div className="font-serif text-4xl leading-none">10+</div>
              <div className="text-xs mt-2 text-white/80">années d'expérience dans la finance & l'assurance</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.25em] text-md-accent font-bold mb-4">À propos</div>
          <h2 className="font-serif text-4xl md:text-5xl text-md-primary font-medium leading-tight mb-7">
            Un courtier <span className="italic">engagé</span>,<br/>
            au service de vos projets.
          </h2>
          <p className="text-md-muted text-lg leading-relaxed mb-5">
            Je m'appelle Maël, et j'ai fondé MD Courtage avec une conviction simple : chacun mérite un conseil financier
            clair, transparent et profondément humain. Banques, assureurs, plateformes : j'ai vu les limites du modèle traditionnel.
          </p>
          <p className="text-md-muted text-lg leading-relaxed mb-10">
            Aujourd'hui, je mets mon expertise et mon réseau au service d'un seul intérêt : <span className="text-md-primary font-medium">le vôtre</span>.
          </p>

          <div className="grid sm:grid-cols-3 gap-5">
            {[
              { icon: Handshake, label: "Courtier en assurance indépendant", desc: "Aucun lien capitalistique avec un assureur, plusieurs partenaires mis en concurrence." },
              { icon: BookOpen, label: "Pédagogie & transparence", desc: "Je vous explique tout. Vous décidez en pleine conscience." },
              { icon: Award, label: "Certifications reconnues", desc: "AMF, IOBSP Niveau 1, IAS Niveau 1, CIF." },
            ].map((b) => {
              const I = b.icon;
              return (
                <div key={b.label} className="p-5 rounded-2xl bg-md-bg border border-md-border">
                  <I className="w-6 h-6 text-md-secondary mb-3" />
                  <div className="font-semibold text-md-primary text-sm mb-1">{b.label}</div>
                  <div className="text-xs text-md-muted leading-relaxed">{b.desc}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
